import FieldRenderer from "./FieldRenderer";
import TableRenderer from "./TableRenderer";
import DerivedRenderer from "./DerivedRenderer";
import GroupedRenderer from "./GroupedRenderer";
import AutoSummaryRenderer from "./AutoSummaryRenderer";
const QuestionRenderer = ({
  question,
  value,
  formData,
  onChange,
  errors,
  isEditable
}) => {

  const schema =
    question.ui_schema || {};

  // ===============================
  // CONDITIONAL
  // ===============================

 if (schema.conditional) {

  let dependencyValue =
    formData[
      schema.conditional
        .question_code
    ];

  // GROUPED FIELD SUPPORT

  if (
    typeof dependencyValue === "object" &&
    schema.conditional.field
  ) {

    dependencyValue =
      dependencyValue?.[
        schema.conditional.field
      ];
  }

  // BOOLEAN NORMALIZATION

  if (
    dependencyValue === 1
  ) {

    dependencyValue = true;
  }

  if (
    dependencyValue === 0
  ) {

    dependencyValue = false;
  }

  if (
    dependencyValue !==
    schema.conditional.value
  ) {

    return null;
  }

}
console.log(
  question.question_code,
  question.evidence
);
  return (

    <div className="le-card ecf-card">

      <div className="ecf-section-header">

        <div className="ecf-section-code">
          {question.question_code}
        </div>

      
<div className="ecf-section-title">

  {question.question_text} <div className="ecf-indicator-type">{question.indicator_type}</div>

  {question.is_required === 1 && (

    <span className="ecf-required-star">
      *
    </span>

  )}

</div>


      </div>

      <div className="ecf-section-body">

{schema.type ===
  "auto_summary" && (() => {

  
  return (

    <AutoSummaryRenderer
  question={question}
  summaryData={
    question.question_code === "P6-Q1"
      ? formData.energy_breakdown
      : question.question_code === "P6-Q3"
      ? formData.water_breakdown
      : question.question_code === "P6-Q6"
      ? formData.ghg_breakdown
      : question.question_code === "P6-Q8"
      ? formData.waste_breakdown
      : {}
  }
  value={value}
  onChange={onChange}
  isEditable={isEditable}
/>

  );

})()}
        {/* SINGLE */}

        {question.input_type ===
          "single" && (

          <FieldRenderer
            question={question}
            value={value}
            onChange={onChange}
            errors={errors}
            isEditable={isEditable}
          />

        )}

        {/* GROUPED */}

        {question.input_type === "grouped" &&
 schema?.type !== "derived" && (

  <GroupedRenderer
    question={question}
    value={value}
    onChange={onChange}
    errors={errors}
    isEditable={isEditable}
  />

)}

        {/* TABLE */}

        {question.input_type ===
          "table" && (

         <TableRenderer
  question={question}
  value={value}
  formData={formData}
  onChange={onChange}
  errors={errors}
  isEditable={isEditable}
/>

        )}

        {/* DERIVED */}

             

        {(
  question.input_type === "derived" ||
  schema?.type === "derived"
) && schema?.type !== "auto_summary" && (() => {
          

          question.ui_schema?.fields?.forEach(
            (field) => {

             /* console.log(
                    "FIELD",
                    question.ui_schema
                      ?.source_question_code,
                    formData?.[
                      question.ui_schema
                        ?.source_question_code
                    ]
                  ); */

            }
          );

          return (

            <DerivedRenderer
  question={question}
  formData={formData}
  onChange={onChange}
  isEditable={isEditable}
/>

          );

        })()}
{question.upload_evidence === 1 && (

  <div className="ecf-evidence-upload">

    <label>

      Supporting Evidence

      {question.evidence_required === 1 && (

        <span className="ecf-required-star">
          *
        </span>

      )}

    </label>

    <input
      type="file"
      multiple
      onChange={(e) => {

        const files =
          Array.from(
            e.target.files || []
          );

        onChange(
          question.question_code,
          {
            ...(value || {}),
            evidence_files: files
          }
        );

      }}
    />

  </div>

)}

{/* Existing Files */}

{question.evidence?.length > 0 && !value?.remove_evidence && (

  <div className="ecf-evidence-upload">

    <div className="ecf-uploaded-title">
      Existing Files
    </div>

    {question.evidence.map((file, index) => (

  <div
    key={index}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }}
  >

    <a
      href={file.file_url}
      target="_blank"
      rel="noreferrer"
    >
      {file.file_name}
    </a>

    {isEditable && (

      <button className="ecf-remove-btn"
        type="button"
        onClick={() => {

          onChange(
            question.question_code,
            {
              ...(value || {}),
              remove_evidence: true
            }
          );

        }}
      >
        ✕
      </button>

    )}

  </div>

))}

  </div>

)}

{/* Newly Selected Files */}

{value?.evidence_files?.length > 0 && (

  <div className="ecf-evidence-upload">

    <div className="ecf-uploaded-title">
      New Files
    </div>

    {value.evidence_files.map(
      (file,index) => (

        <div key={index}>
          {file.name}
        </div>

      )
    )}

  </div>

)}
      </div>

    </div>

  );
};

export default QuestionRenderer;